/**
 * Parses user query string to extract city and postal code.
 *
 * @param {string|null|undefined} query
 * @returns {{city: string|undefined, postalCode: string|undefined}}
 */
export function parseQuery(query) {
  const input = query?.trim();

  const cityRegex = /^[A-Za-z\s]+/; // Match city names (alphabetic and spaces only) at the start
  const postalCodeRegex = /\b\d{1,10}\b/; // Match postal codes (numbers or alphanumeric)

  const cityMatch = input?.match(cityRegex);
  const postalCodeMatch = input?.match(postalCodeRegex);

  return {
    city: cityMatch?.at(0)?.trim(),
    postalCode: postalCodeMatch?.at(0)?.trim(),
  };
}
